import styled from 'styled-components';
import {flexUnit} from '../../global-styles/mixins.js';

const StyledContactWrap = styled.div`
  position: relative;
  padding-right: 64px;
  padding-left: 64px;
  margin-top: ${props => props.theme.components_spacing_desk.medium}px;
  margin-bottom: ${props => props.theme.components_spacing_desk.xlarge}px;

  .contact--slider{
    position: relative;
    width: 100%;
  }
  .step-title{
    margin-bottom: ${props => props.theme.components_spacing_desk.medium}px;
  }
  .contact--selection-wrap{
    position: relative;
    width: 100%;
    display: flex;
    flex-flow: row wrap;
  }
  .contact--selection{
    padding: 16px 48px 24px;
    border: 1px solid #CCCCCC;
    border-radius: 48px;
    margin-right: 24px;
    margin-bottom: 24px;
    background-color: #fff;
    color: #000;
    cursor: pointer;
    transition: color .25s, background-color .25s, border-color .25s;
  }
  .contact--selection.selected{
    background-color: ${props => props.theme.colors.green_secondary};
    color:#fff;
    border-color: transparent;
  }
  .first--step{
    position: relative;
    width: 83.33%;
    z-index: 2;
  }
  .form--step{
    position: absolute;
    opacity: 0;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
  }
  .form-type{
    color: #999999;
    margin-bottom: ${props => props.theme.components_spacing_desk.medium}px;
  }
  .form--wrap{
    position: relative;
    width: 100%;
  }
  .input--wrap{
    width: calc(33.33% + 96px);
  }

  .last-step .input--wrap{
    width: 66.66%;
  }
  .input--wrap-step{
    position: absolute;
    opacity: 0;
    z-index: 1;
    visibility: hidden;
    top: 0;
    left: 0;
    pointer-events: none;
  }
  .input--wrap-step.selected{
    position: relative;
    opacity: 1;
    z-index: 2;
    visibility: visible;
    pointer-events: all;
  }
  .input--wrap-step h6{
    margin-bottom: ${props => props.theme.components_spacing_desk.medium}px;
  }
  .input--wrap-row{
    position: relative;
    display: flex;
    align-items: baseline;
    justify-content: flex-start;
  }
  .input--wrap-row img{
    flex: 0 0 64px;
    margin-left: 32px;
    cursor: pointer;
  }
  input{
    ${flexUnit(4, 28, 43, 'vw', 'font-size')};
    line-height: 130%;
    flex: 0 0 calc(100% - 96px);
    width: calc(100% - 96px);
    letter-spacing: -.05em;
    font-family: 'Alliance No.2', sans-serif;
    font-weight: 400;
    border: none;
    outline: transparent !important;
    border-bottom: 1px solid #000;
  }
  .error input{
    border-bottom: 1px solid #D1495B;
  }
  .error input#--comments{
    border-bottom: 1px solid #000;
  }
  .error-text{
    color: #D1495B;
    padding-top: 16px;
  }
  .comments-check{
    padding-top: 16px;
    padding-bottom: 32px;
    color: #4D4D4D;
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
  }
  .comments-check span:nth-child(2){
    margin-right: 96px;
  }
  .input--wrap-row.terms--row{
    align-items: flex-start;
  }
  .check--terms{
    width: 44px;
    height: 44px;
    border: 1px solid #B3B3B3;
    flex: 0 0 44px;
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .check--terms img{
    display: none;
  }
  .check--terms.checked{
    background-color: ${props => props.theme.colors.green_secondary};
    border-color: ${props => props.theme.colors.green_secondary};
  }
  .check--terms.checked img{
    display: block;
    margin: 0 auto;
    flex: 0 0 24px;
    width: 24px;
  }
  .terms--row{
    color: #B3B3B3;
  }
  .terms--row a{
    color: ${props => props.theme.colors.green_secondary};
  }
  .error .check--terms{
    border: 1px solid #D1495B;
  }

  .last-step .error--message p{
    padding-left: 60px;
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px;
  }
  @media screen and (max-width: 1023px){
    margin-top: ${props => props.theme.components_spacing_tablet.medium}px;
    margin-bottom: ${props => props.theme.components_spacing_tablet.xlarge}px;
    .step-title{
      margin-bottom: ${props => props.theme.components_spacing_tablet.medium}px;
    }
    .form-type{
      color: #999999;
      margin-bottom: ${props => props.theme.components_spacing_tablet.medium}px;
    }
    .input--wrap-step h6{
      margin-bottom: ${props => props.theme.components_spacing_desk.medium}px;
    }
    .contact--selection{
      padding: 12px 16px 16px;
    }
    .input--wrap{
      width: 66.66%;
    }
    .last-step .input--wrap{
      width: 100%;
    }
  }
  @media screen and (max-width: 767px){
    margin-top: ${props => props.theme.components_spacing_mobile.medium}px;
    margin-bottom: ${props => props.theme.components_spacing_mobile.xlarge}px;
    padding-right: 24px;
    padding-left: 24px;
    .step-title{
      margin-bottom: ${props => props.theme.components_spacing_mobile.medium}px;
    }
    .contact--selection{
      border-radius: 48px;
      margin-right: 16px;
      margin-bottom: 16px;
      padding: 16px;
    }
    .contact--selection h6{
      font-size: 14.4px;
    }
    .form-type{
      color: #999999;
      margin-bottom: ${props => props.theme.components_spacing_mobile.medium}px;
    }
    .input--wrap-step h6{
      margin-bottom: ${props => props.theme.components_spacing_desk.medium}px;
    }
    .input--wrap{
      width: 100%;
    }
    .input--wrap-row img{
      flex: 0 0 32px;
      margin-left: 24px;
      cursor: pointer;
      width: 32px;
    }
  }
  
  .loader {
    flex: 0 0 32px;
    margin-left: 32px;
    border: 3px solid #fff;
    border-radius: 50%;
    border-top: 3px solid ${props => props.theme.colors.green_secondary};
    width: 32px;
    height: 32px;
    animation: spin .75s ease-out infinite;
  }
  .thankyou-check{
    border-radius: 50%;
    background-color: ${props => props.theme.colors.green_secondary};
    width: 48px;
    height: 48px;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .thankyou-check img{
    width: 24px;
  }
  .thank--you h6{
    margin-bottom: 40px;
  }
  .thank--you p{
    color: #4D4D4D;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .img--wrap{
    position: absolute;
    width: 33.33%;
    right: -16%;
    top: 0;
    transform:translate(-50%, -50%);
  }
  .img--wrap img{
    display: block;
    width: 100%;
  }
  @media screen and (max-width: 1023px){
    .img--wrap{
      display: none;
    }
  }
`;

export {
  StyledContactWrap,
};

